module.exports = __webpack_public_path__ + "img/BOC.8589e5ad.png";